import script from "./SummaryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryPage.vue?vue&type=script&setup=true&lang=js"

import "./SummaryPage.vue?vue&type=style&index=0&id=86928880&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86928880"]])

export default __exports__